export default function CommunityCTA() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-brand-500 to-accent-600 p-10 lg:p-16 text-center">
          {/* Decorative blobs */}
          <div className="absolute -top-12 -left-12 w-48 h-48 rounded-full bg-white/10 pointer-events-none" />
          <div className="absolute -bottom-12 -right-12 w-64 h-64 rounded-full bg-white/10 pointer-events-none" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full bg-white/5 pointer-events-none" />

          <div className="relative z-10">
            {/* Icon */}
            <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-6">
              <i className="ri-heart-fill text-white text-2xl"></i>
            </div>

            {/* Headline */}
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-5 font-heading leading-tight">
              We would love to connect with you.
            </h2>

            <p className="text-white/80 text-lg max-w-xl mx-auto font-body leading-relaxed mb-10">
              Whether you are a parent, patient, caregiver, researcher, or simply someone who cares — you belong here. Reach out and let us know how we can help.
            </p>

            {/* Action buttons */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
              <a
                href="#updates-form"
                className="px-8 py-4 bg-white text-brand-600 font-bold rounded-full hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer font-body flex items-center gap-2"
              >
                <i className="ri-mail-send-line"></i>
                Sign Up for Updates
              </a>
              <a
                href="#story-form"
                className="px-8 py-4 bg-white/15 border-2 border-white/40 text-white font-semibold rounded-full hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer font-body flex items-center gap-2"
              >
                <i className="ri-quill-pen-line"></i>
                Share Your Story
              </a>
            </div>

            {/* Contact line */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-white/60 text-sm font-body">
              <div className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>hello@cscfsupport.org</span>
              </div>
              <div className="hidden sm:block w-px h-4 bg-white/30" />
              <div className="flex items-center gap-2">
                <i className="ri-facebook-circle-line"></i>
                <span>CSCF Support Community</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
